import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserData } from '../../../hooks'
import { isManagerUser } from '../../../utils/user'
import { FormFieldSelectNG } from '../../Form'
import { FormikField } from '../../Formik'
import { InputSelect } from '../../Select'
import Text from '../../Text'

import { DOCUMENT_ACCESS_LEVEL_FIELD_ROWS } from './DocumentAccessLevelField.constants'
import {
  getAccessLevelNextValue,
  getAccessLevelOptions,
  getAccessLevelValueProps,
} from './DocumentAccessLevelField.utils'

import * as styles from './DocumentAccessLevelField.module.css'

function DocumentAccessLevelField({ name, onChangeAccess }) {
  const { t } = useTranslation()

  const user = useUserData()

  const isManagerUserAcc = isManagerUser(user)

  function getHandleChangeAccess(nameKey) {
    return option => {
      onChangeAccess?.(nameKey, option.value)
    }
  }

  return (
    <div className={styles.AccessLevelField}>
      {DOCUMENT_ACCESS_LEVEL_FIELD_ROWS.map(row => {
        const options = getAccessLevelOptions(t)

        return (
          <Fragment key={row.nameKey}>
            <Text>{t(row.labelKey)}</Text>
            <FormikField
              Component={FormFieldSelectNG}
              Field={Fragment}
              Select={InputSelect}
              controlProps={{
                indicatorsProps: {
                  ButtonClear: null,
                },
              }}
              disabled={row.isAdmin || (row.isManager && isManagerUserAcc)}
              getNextValue={getAccessLevelNextValue}
              getValueProps={getAccessLevelValueProps(options)}
              name={name[row.nameKey]}
              options={options}
              qaName={row.qaName}
              onChange={getHandleChangeAccess(row.nameKey)}
            />
          </Fragment>
        )
      })}
    </div>
  )
}

export default DocumentAccessLevelField
